define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var ConversationSourcesGalleryModel = require("manager-models/data-sources/conversation-sources/ConversationSourcesGalleryModel");

    var NAME = "ConversationSourcesGalleryCollection";

    var ConversationSourcesGalleryCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ConversationSourcesGalleryCollection = BaseCollection.extend({
            model: ConversationSourcesGalleryModel,
            name: NAME
        });

    }

    LE.module("LEManager", moduleDefinition);

    ConversationSourcesGalleryCollection.NAME = NAME;

    return ConversationSourcesGalleryCollection;
});
